@use "../../styles/breakpoint.module.scss" as *;

.modal {
    position: fixed;
    inset: 0;
    z-index: 100;
}

.dialog {
    composes: safeGridContainer from "../../styles/composable/layout.module.css";
    align-items: center;
    height: 100%;
    outline: 0;
}

.overlay {
    position: absolute;
    inset: 0;
    z-index: 0;
}

.overlayDark {
    background-color: var(--overlay-black-80);
}

.overlayMedium {
    background-color: var(--overlay-black-56);
}

.overlayLight {
    background-color: var(--overlay-black-20);
}

.content {
    position: relative;
    z-index: 1;
    max-height: 94vh;
    max-height: 94dvh;
    overflow-y: auto;
}

:where(.content) {
    padding: var(--spacer-48);

    @media ($below-mobile) {
        padding: var(--spacer-32) var(--spacer-24);
    }
}

.close {
    position: absolute;
    top: var(--spacer-24);
    right: var(--spacer-24);
    width: var(--spacer-32);
    height: var(--spacer-32);
    fill: currentColor;
    z-index: 1;
}

@media (prefers-reduced-motion: no-preference) {
    .modal {
        transition: opacity 0.3s;
    }

    .modal[data-entering],
    .modal[data-exiting] {
        opacity: 0;
    }
}
